import { render, staticRenderFns } from "./AddNew.vue?vue&type=template&id=4e658a04&scoped=true"
import script from "./AddNew.vue?vue&type=script&lang=js"
export * from "./AddNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e658a04",
  null
  
)

export default component.exports